export function submitManualProcess()
{
    return({
        type:"SUBMIT_MANUAL_PROCESS"
    })
}